import { createModel } from '@/store/tools';

const model = {
    namespace: 'employee',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getEmplList': T('getEmplList'),
            'getDeptPullDown': T('getDeptPullDown'),
            'getDeptList': T('getDeptList'),
            'getZdList': T('getZdList'),
        },
        actions: {
            'getEmplList': A('getEmplList'),
            'getDeptPullDown': A('getDeptPullDown'),
            'getDeptList': A('getDeptList'),
            'getZdList': A('getZdList'),
        },
        sagas: {
            'getEmplList': S('getEmplList', '/?cmd=com.xqxc.api.pig.mis.biz.account.EmplMisService.findEmplPage'),
            'getDeptPullDown': S('getDeptPullDown', '/?cmd=com.xqxc.api.pig.mis.biz.account.DeptMisService.listDeptPullDown'),
            'getDeptList': S('getDeptList', '/?cmd=com.xqxc.api.pig.mis.biz.account.DeptMisService.listDeptTreeStructure'),
            'getZdList': S('getZdList', '/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.zdList'),
        },
        reducers: {
            'getEmplList': R('getEmplList', { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }),
            'getDeptPullDown': R('getDeptPullDown', []),
            'getDeptList': R('getDeptList', []),
            'getZdList': R('getZdList', []),
        }
    })
};
export default createModel(model);